"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Link = _interopRequireDefault(require("../Link"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var HomeLink = function HomeLink(props) {
  var children = props.children,
      other = (0, _objectWithoutProperties2.default)(props, ["children"]);
  var t = (0, _useTranslation.default)();
  return (0, _core.jsx)(_Link.default, (0, _extends2.default)({
    icon: "Home"
  }, other), t('home'));
};

__signature__(HomeLink, "useTranslation{t}", function () {
  return [_useTranslation.default];
});

var _default = HomeLink;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(HomeLink, "HomeLink", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/HomeLink.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Mobile/HomeLink.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL01vYmlsZS9Ib21lTGluay50c3giXSwibmFtZXMiOlsiSG9tZUxpbmsiLCJwcm9wcyIsImNoaWxkcmVuIiwib3RoZXIiLCJ0IiwidXNlVHJhbnNsYXRpb24iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFHQTs7QUFFQTs7Ozs7Ozs7Ozs7OztBQUlBLElBQU1BLFFBQVEsR0FBRyxTQUFYQSxRQUFXLENBQTZCQyxLQUE3QixFQUF5RDtBQUFBLE1BQ2hFQyxRQURnRSxHQUN6Q0QsS0FEeUMsQ0FDaEVDLFFBRGdFO0FBQUEsTUFDbkRDLEtBRG1ELDBDQUN6Q0YsS0FEeUM7QUFFeEUsTUFBTUcsQ0FBQyxHQUFHLDhCQUFWO0FBRUEsU0FDRSxlQUFDLGFBQUQ7QUFBTSxJQUFBLElBQUksRUFBQztBQUFYLEtBQXVCRCxLQUF2QixHQUNHQyxDQUFDLENBQUMsTUFBRCxDQURKLENBREY7QUFLRCxDQVREOztjQUFNSixRO1VBRU1LLHVCOzs7ZUFTR0wsUTs7Ozs7Ozs7Ozs7OzBCQVhUQSxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgR2VuZXJpY0NvbXBvbmVudCB9IGZyb20gJy4uLy4uL3R5cGVzL3dpdGgtYXMtcHJvcCc7XG5pbXBvcnQgTGluayBmcm9tICcuLi9MaW5rJztcbmltcG9ydCB7IExvZ29Qcm9wcyB9IGZyb20gJy4uL0xvZ28nO1xuaW1wb3J0IHVzZVRyYW5zbGF0aW9uIGZyb20gJy4uL1RyYW5zbGF0aW9uUHJvdmlkZXIvdXNlVHJhbnNsYXRpb24nO1xuXG5leHBvcnQgdHlwZSBIb21lTGlua1Byb3BzPFQgZXh0ZW5kcyBHZW5lcmljQ29tcG9uZW50PiA9IExvZ29Qcm9wczxUPjtcblxuY29uc3QgSG9tZUxpbmsgPSA8VCBleHRlbmRzIEdlbmVyaWNDb21wb25lbnQ+KHByb3BzOiBIb21lTGlua1Byb3BzPFQ+KSA9PiB7XG4gIGNvbnN0IHsgY2hpbGRyZW4sIC4uLm90aGVyIH0gPSBwcm9wcztcbiAgY29uc3QgdCA9IHVzZVRyYW5zbGF0aW9uKCk7XG5cbiAgcmV0dXJuIChcbiAgICA8TGluayBpY29uPVwiSG9tZVwiIHsuLi4ob3RoZXIgYXMgYW55KX0+XG4gICAgICB7dCgnaG9tZScpfVxuICAgIDwvTGluaz5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEhvbWVMaW5rO1xuIl19